import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { tokenStorage } from '@/entities/auth/model/tokenStorage';
import { AuthService } from '@/shared/api';
import { ROUTES } from '@/shared/constants/routes';
import { authEvents } from '@/shared/lib/authEvents';

export const CallbackYandexPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const auth = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        const savedState = localStorage.getItem('yandex_oauth_state');

        if (!code || !state) {
          throw new Error('Нет code или state');
        }

        if (savedState !== state) {
          throw new Error('State mismatch');
        }

        const response = await AuthService.v1AuthYandexCallbackCreate({
          body: {
            code,
            state,
          },
        });

        tokenStorage.save({
          access: response.access_token,
          refresh: response.refresh_token,
          phone: '',
        });

        authEvents.emit('LOGIN_SUCCESS');

        localStorage.removeItem('yandex_oauth_state');

        const redirectTo =
          localStorage.getItem('post_auth_redirect') || ROUTES.home();

        localStorage.removeItem('post_auth_redirect');

        navigate(redirectTo, {
          replace: true,
        });
      } catch (e) {
        console.error(e);

        localStorage.removeItem('yandex_oauth_state');

        const redirectTo =
          localStorage.getItem('post_auth_redirect') || ROUTES.home();

        localStorage.removeItem('post_auth_redirect');

        navigate(redirectTo, {
          replace: true,
        });
      }
    };

    auth();
  }, [navigate, searchParams]);

  return <div>Авторизация через Яндекс...</div>;
};
